import { EventBus } from '../eventBus';

// 定义用户信息接口
export interface UserInfo {
  user_id: string;
  username: string;
  full_name?: string;
  email?: string;
  avatar?: string;
  login_time: number;
  corp_id?: string;
}

// 定义在线状态数据接口
export interface OnlineStatusData {
  online_count: number;
  recent_users: UserInfo[];
}

// 定义事件类型
export const ONLINE_STATUS_EVENTS = {
  STATUS_UPDATED: 'online-status:updated',
};

// 全局在线状态服务类
class OnlineStatusService {
  private static instance: OnlineStatusService;
  private eventBus: EventBus;
  
  // 在线状态数据
  private data: OnlineStatusData = {
    online_count: 0,
    recent_users: []
  };
  
  // 最大最近用户数量
  private maxRecentUsers: number = 30;
  
  // 是否已初始化
  private initialized: boolean = false;

  // 私有构造函数，确保单例模式
  private constructor() {
    this.eventBus = EventBus.getInstance();
  }

  // 获取单例实例
  public static getInstance(): OnlineStatusService {
    if (!OnlineStatusService.instance) {
      OnlineStatusService.instance = new OnlineStatusService();
    }
    return OnlineStatusService.instance;
  }

  // 初始化服务
  public init(maxRecentUsers: number = 30): void {
    if (this.initialized) return;
    
    this.maxRecentUsers = maxRecentUsers;
    this.initialized = true;
    
    console.log('OnlineStatusService initialized');
  }

  // 更新在线状态数据
  public updateStatus(data: OnlineStatusData): void {
    // 更新数据
    this.data = {
      online_count: data.online_count,
      // 限制最近用户数量
      recent_users: data.recent_users.slice(0, this.maxRecentUsers)
    };
    
    // 通知所有订阅者
    this.notifyStatusUpdated();
  }

  // 获取当前在线状态数据
  public getStatus(): OnlineStatusData {
    return { ...this.data };
  }

  // 获取在线用户数量
  public getOnlineCount(): number {
    return this.data.online_count;
  }

  // 获取最近登录用户
  public getRecentUsers(limit?: number): UserInfo[] {
    if (limit && limit > 0) {
      return this.data.recent_users.slice(0, limit);
    }
    return [...this.data.recent_users];
  }

  // 订阅状态更新事件
  public subscribeToStatusUpdates(callback: (data: OnlineStatusData) => void): () => void {
    return this.eventBus.subscribe(ONLINE_STATUS_EVENTS.STATUS_UPDATED, callback);
  }

  // 通知所有订阅者状态已更新
  private notifyStatusUpdated(): void {
    this.eventBus.publish(ONLINE_STATUS_EVENTS.STATUS_UPDATED, this.data);
  }

  // 重置状态（主要用于测试）
  public reset(): void {
    this.data = {
      online_count: 0,
      recent_users: []
    };
    this.notifyStatusUpdated();
  }
}

// 导出单例实例
export const onlineStatusService = OnlineStatusService.getInstance();

// 默认导出
export default onlineStatusService; 